module.exports = __webpack_public_path__ + "static/img/2.e783db8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/2.jpg
// module id = cU8u
// module chunks = 16